<ng-progress [spinner]="false" [color]="'#7ab655'"></ng-progress>
<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="d-sm-flex align-items-center justify-content-between mb-4" style="margin-bottom: 9px;margin-right: 1px;">
                    <h1 class="h3 mb-0 text-gray-800">MOD 1 Assessments </h1>
                </div>

                <ng-container *ngIf="loading">
                    <div class="loading text-center">
                        <br />
                        <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                        <br />
                        <p>Loading, please wait...</p>
                    </div>
                </ng-container>

                <div class="topSpacing" *ngIf="!loading">
                    <div class="row">
                        <div class="col-xs-12 col-sm-4 assessmentsModlll" style="display:flex;">
                            <label>Date: </label>
                            <!--<select #date id="selectDate" (change)="getAssessmentsValues(date.value)">
                                <option *ngFor="let date of mod3Dates" value="{{date.Value}}">{{date.Text}}</option>
                            </select>-->

                        <!-- NEW DATE PICKER -->
                        <input id="mod3InputDatePicker" type="date" [(ngModel)]="todayDate" (change)="getAssessmentsValues(todayDate)">
                        <!-- NEW DATE PICKER -->

                            <!-- <angular2-date-picker style="margin-left: 5px;margin-top:1px; width:207px;" (onDateSelect)="getAssessmentsValues()" [(ngModel)]="todayDate" [settings]="settings"></angular2-date-picker> -->
                        </div>

                        <ng-container *ngIf="currentSelectedTab == 1">
                            <div class="actBtns col-xs-12 col-sm-8 text-right">
                                <!--*ngIf="!backgroundProcessInProgressFlag"-->
                                <!--<a (click)="createGroup()" data-toggle="dropdown" class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm">
                                    <i class="fas fa-plus text-white-50"> <span class="button-text"> Create Group</span></i>
                                </a>-->

                                <a *ngIf="synchronizing == false; else syncElse;" (click)="syncBtn()" data-toggle="dropdown" class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm margin-right-5">
                                    <i class="fas fa-sync text-white-50"> <span class="button-text"> Sync</span></i>
                                </a>
                                <ng-template #syncElse>
                                    <button disabled class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm loadingBtn">
                                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Synchronizing
                                    </button>
                                </ng-template>

                                <a *ngIf="!getStudentsFlag; else getStudentsFlagElse;" (click)="getStudents()" data-toggle="dropdown" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                    <i class="fas fa-download text-white-50"> <span class="button-text"> Get Students</span></i>
                                </a>

                                <ng-template #getStudentsFlagElse>
                                    <button disabled class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm readyBtn">
                                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Getting Students
                                    </button>
                                </ng-template>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="currentSelectedTab == 2">
                            <div class="actBtns col-xs-12 col-sm-8 text-right">
                                <a (click)="showAddStudentModal()" data-toggle="dropdown" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm margin-right-5">
                                    <i class="fas fa-plus text-white-50"> <span class="button-text"> Add Student</span></i>
                                </a>

                                <!--DEFER-->
                                <!--<a (click)="displayDeferModal()" class="d-none d-sm-inline-block btn btn-sm btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-primary': canDefer, 'btn-gray': !canDefer}">
                                    <i class="far fa-calendar-alt text-white-50"> <span class="button-text"> Defer</span></i>
                                </a>-->

                                <!--*ngIf="showReminderBtn"-->
                                <!--REMINDER-->
                                <a *ngIf="reminding == false; else remindingElse;" (click)="sendReminder()" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-other': canRemind, 'btn-gray': !canRemind}">
                                    <i class="fas fa-send text-white-50"> <span class="button-text"> Remind</span></i>
                                </a>

                                <ng-template #remindingElse>
                                    <button disabled class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm loadingBtn">
                                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Reminding
                                    </button>
                                </ng-template>

                                <!--UNASSIGN-->
                                <a (click)="openConfirmModal()" class="d-none d-sm-inline-block btn btn-sm shadow-sm" [ngClass]="{'btn-red': canUnassign, 'btn-gray': !canUnassign }">
                                    <i class="fas fa-user-times text-white-50"> <span class="button-text"> Unassign</span></i>
                                </a>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="currentSelectedTab == 3">
                            <div class="actBtns col-xs-12 col-sm-8 text-right">
                                <!--ENABLE RESULTS-->
                                <a *ngIf="!enabling; else enablingResults;" id="enableResults" (click)="enableResults()" [ngClass]="{'btn-other': canEnableResults, 'btn-gray': !canEnableResults}" class="d-none d-sm-inline-block btn btn-sm  shadow-sm margin-right-5">
                                    <i class="fas fa-toggle-on text-white-50"> <span class="button-text"> Enable Results</span></i>
                                </a>

                                <ng-template #enablingResults>
                                    <button disabled class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm readyBtn">
                                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Enabling Results
                                    </button>
                                </ng-template>

                                <!--ASSIGN ASSESSMENTS-->
                                <a (click)="assignAssessmentsModlll()" id="downloadBtn" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-primary': canAssign, 'btn-gray': !canAssign}">
                                    <i class="fas fa-plus text-white-50"> <span class="button-text"> Add Assessments</span></i>
                                </a>

                                <!--DEFER-->
                                <!--<a (click)="displayDeferModal()" class="d-none d-sm-inline-block btn btn-sm btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-primary': canDefer, 'btn-gray': !canDefer}">
                                    <i class="far fa-calendar-alt text-white-50"> <span class="button-text"> Defer</span></i>
                                </a>-->

                                <!--DOWNLOAD REPORTS-->
                                <a *ngIf="!downloading; else downloadingReports;" (click)="downloadReportAssessmentModl()" id="downloadBtn" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-primary': canDownload, 'btn-gray': !canDownload}">
                                    <i class="fas fa-download text-white-50"> <span class="button-text"> Download Reports</span></i>
                                </a>

                                <ng-template #downloadingReports>
                                    <button disabled class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm readyBtn">
                                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Downloading Reports
                                    </button>
                                </ng-template>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <ng-container> <!--*ngIf="displayContent; else displayContentElse;"-->
                    <div class="loading" *ngIf="!loading;">  <!--else loadingElse-->
                        <div>
                            <ul class="tab-nav">
                                <li (click)="selectedTab(1)" class="active"><a data-toggle="tab" href="#Tab1">Stats</a></li>
                                <li (click)="selectedTab(2)"><a data-toggle="tab" href="#Tab2">Pending</a></li>
                                <li (click)="selectedTab(3)"><a data-toggle="tab" href="#Tab3">Completed</a></li>
                            </ul>
                        </div>

                        <div class="main-tab-content tab-content">
                            <div id="Tab1" class="tab-pane fade main-content in active">
                                <div style="display:flex;"><h5 style="width:150px;">Total Students: </h5>   <h5 style="padding-left:10px;"><b>{{totalStudents}}</b></h5></div>
                                <div style="display:flex;"><h5 style="width:150px;">Pending: </h5>          <h5 style="padding-left:10px;"><b>{{pending}}</b></h5></div>
                                <div style="display:flex;"><h5 style="width: 150px;">Completed: </h5>        <h5 style="padding-left:10px;"><b>{{completed}}</b></h5></div>
                            </div>

                            <div id="Tab2" class="tab-pane fade">
                                <div style="width: 100%; max-height: 400px; height:400px;">
                                    <ag-grid-angular #agGrid
                                                     style="width: 100%; height: 100%;"
                                                     class="ag-theme-balham"
                                                     [enableFilter]="true"
                                                     [floatingFilter]="true"
                                                     [gridOptions]="gridOptions"
                                                     [rowData]="pendings"
                                                     [columnDefs]="pendingsHeaders"
                                                     [enableSorting]="true"
                                                     [enableColResize]="true"
                                                     (rowClicked)="onRowClicked($event)"
                                                     (gridReady)="onGridReady($event, 1)"
                                                     [pagination]="true"
                                                     [paginationPageSize]="25"
                                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                     [rowSelection]="'multiple'"
                                                     (rowSelected)="onRowSelected($event)"
                                                     (selectionChanged)="onSelectionChanged($event, 1)"
                                                     [rowMultiSelectWithClick]="true"
                                                     [suppressRowClickSelection]="true">
                                    </ag-grid-angular>
                                </div>
                            </div>

                            <div id="Tab3" class="tab-pane fade">
                                <div style="width: 100%; max-height: 400px; height:400px;">
                                    <ag-grid-angular #agGridcompleted
                                                     style="width: 100%; height: 100%;"
                                                     class="ag-theme-balham"
                                                     [enableFilter]="true"
                                                     [floatingFilter]="true"
                                                     [gridOptions]="gridOptions"
                                                     [rowData]="completedData"
                                                     [columnDefs]="completedHeaders"
                                                     [enableSorting]="true"
                                                     [enableColResize]="true"
                                                     (rowClicked)="onRowClicked($event)"
                                                     (gridReady)="onGridReady($event, 2)"
                                                     [pagination]="true"
                                                     [paginationPageSize]="25"
                                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                     [rowSelection]="'multiple'"
                                                     (rowSelected)="onRowSelected($event)"
                                                     (selectionChanged)="onSelectionChanged($event, 2)"
                                                     [rowMultiSelectWithClick]="true"
                                                     [suppressRowClickSelection]="true">
                                    </ag-grid-angular>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ng-template>
                        <div class="loading text-center">
                            <br />
                            <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                            <br />
                            <p>Loading, please wait...</p>
                        </div>
                    </ng-template>
                </ng-container>
                <!--<ng-template #displayContentElse>
                    <ng-container *ngIf="!creatingGroupFlag; else creatingGroupElse; ">
                        <div style="padding: 0px 15px;border: 1px solid #ddd;background-color: white;min-height: 450px;margin-top: 15px;">
                            <h4>No group has been created for this date.</h4>
                        </div>
                    </ng-container>

                    <ng-template #creatingGroupElse>
                        <div style="padding: 0px 15px;border: 1px solid #ddd;background-color: white;min-height: 450px;margin-top: 15px;">
                            <div>
                                <h4><i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Creating group for this date.</h4>
                                <p style="font-size:15px;">You can continue using the system meanwhile the group is being created in background</p>
                            </div>
                        </div>
                    </ng-template>
                </ng-template>-->
            </div>
        </div>
    </div>
</div>

<!--/*UNASSIGN CONFIRMATION MODAL*/-->
<div id="confirmModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Assessment</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <span *ngIf="!unassigning" style="font-size:17px;">Are you sure you want to unassign the selected assessments?</span>
                <img *ngIf="unassigning" src="../../../assets/img/gif/redLoading.gif" width="50" height="50" alt="In progress..." />
                <p *ngIf="unassigning" style="font-size:12px;">Loading...</p>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div *ngIf="!unassigning" class="col-md-12 text-center">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                        <button (click)="confirm()" type="button" class="btn btn-primary">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*Add client modal*/-->
<div id="addStudentModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Add Student</h2>
                <button type="button" class="close" (click)="hideAddStudentModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-xs-12 col-sm-2 noPadding text-right">
                        <label><b style="color:#000;">Email: </b></label>
                    </div>
                    <div class="col-xs-12 col-sm-10 noPadding">
                        <input email placeholder="Email" #email (keypress)="preventSpace(email.value, $event, 'assessmentsMod3NewEmail')" type="email" value="" id="assessmentsMod3NewEmail" />
                        <!--[readonly]="action == 'Edit'" [ngClass]="{'input_readonly': action == 'Edit'}"-->
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="row" style="padding: 0 15px;">
                    <div class="col-md-12">
                        <ng-container *ngIf="addingStudent == false; else addingStudentElse;">
                            <button (click)="hideAddStudentModal()" type="button" class="btn btn-secondary">Cancel</button>
                            <button (click)="addStudent(email.value)" type="button" class="btn btn-primary">Add</button>
                        </ng-container>

                        <ng-template #addingStudentElse>
                            <button disabled class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm loadingBtn">
                                <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Adding
                            </button>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*deferModal modal*/-->
<div id="deferModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Defer Students</h2>
                <button type="button" class="close" (click)="hideDeferModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body" style="display: flex;">
                <label style="width: 65px;">To date:</label>
                <!-- <angular2-date-picker style="margin-left: 5px;margin-top:1px; width:207px;" (onDateSelect)="deferSelectedDate()" [(ngModel)]="todaysDate" [settings]="settings"></angular2-date-picker> -->
            </div>
            <div class="modal-footer">
                <div class="row" style="padding: 0 15px;">
                    <div class="col-md-12">
                        <ng-container *ngIf="!deferring; else deferStudentElse;">
                            <button (click)="hideDeferModal()" type="button" class="btn btn-secondary">Cancel</button>
                            <button (click)="okDeferStudents()" type="button" class="btn btn-primary">Ok</button>
                        </ng-container>

                        <ng-template #deferStudentElse>
                            <button disabled class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm loadingBtn">
                                <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Deferring
                            </button>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*create group modal*/-->
<div id="createGroupModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Create Group</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body" style="display: flex;">
                <p>This will create a new MOD 3 group for <b>{{ getInputDateValue(true) }}</b> and will send the invitation messages for the group students. Do you want to continue?</p>
            </div>
            <div class="modal-footer">
                <div class="row" style="padding: 0 15px;">
                    <div class="col-md-12">
                        <ng-container *ngIf="!creatingGroupFlag; else creatingGroupElse;">
                            <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                            <button (click)="okCreateGroup()" type="button" class="btn btn-primary">Yes</button>
                        </ng-container>

                        <ng-template #creatingGroupElse>
                            <button disabled class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm loadingBtn">
                                <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Creating Group
                            </button>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--assign assessments MODAL-->
<div class="modal fade" id="assignAssessmentsModlllModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div class="text-center">
                    <h2 class="modal-title text-center"><span class="capitalize">Assign Assessments</span></h2>
                </div>
                <button (click)="hideAssignAssessmentsModal()" type="button" class="close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-md-8">
                        <p>ELI Self Assessment</p>
                    </div>
                    <div class="col-md-4">
                        <input [(ngModel)]="quantity" inputmode="numeric" type="number" min="1" step="1" max="999" id="quantity" (keyup)="allowOnlyNumber($event)" />
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <ng-container *ngIf="!assigningAssessmentsFlag; else assigningAssessmentsElse;">
                    <input (click)="hideAssignAssessmentsModal()" type="button" class="btn btn-secondary" name="close" value="Cancel" />
                    <input type="button" [disabled]="quantity == 0" (click)="okAssignAssessmentsModlll()" class="btn btn-primary waves-effect" value="Ok" />
                </ng-container>

                <ng-template #assigningAssessmentsElse>
                    <button disabled class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm loadingBtn">
                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Assigning Assessments
                    </button>
                </ng-template>
            </div>
        </div>
    </div>
</div>

